export const MeasurementRow = ({ label, value }: { label: string; value?: number | string }) => (
  <div className="flex w-full justify-between">
    <div className="text-s-r text-base-10">{label}</div>
    <div className="text-s-sb">{value ?? '-'}</div>
  </div>
);
